import { vModelText as _vModelText, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-236e912c")

_pushScopeId("data-v-236e912c")
const _hoisted_1 = { class: "position-relative" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("input", {
      ref: "input",
      type: "password",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.localValue = $event)),
      tabindex: _ctx.tabIndex,
      onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitModel(_ctx.localValue))),
      readonly: _ctx.readonly
    }, null, 40, ["tabindex", "readonly"]), [
      [_vModelText, _ctx.localValue],
      [_directive_localizedPlaceholder, { key: _ctx.placeholderKey, value: _ctx.placeholderValue,  prevText: _ctx.placeholderPrevText, afterText: _ctx.placeholderAfterText }]
    ]),
    _createVNode("div", {
      class: "password_div pointer",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeShowPassword()))
    }, [
      (!_ctx.showPassword)
        ? (_openBlock(), _createBlock(_component_localized_text, {
            key: 0,
            localizedKey: "backoffice_mostra",
            text: "Mostra",
            class: "fs_12 fw_500 white"
          }))
        : (_openBlock(), _createBlock(_component_localized_text, {
            key: 1,
            localizedKey: "backoffice_nascondi",
            text: "Nascondi",
            class: "fs_12 fw_500 white"
          }))
    ])
  ]))
})